export default "__VITE_ASSET__GsN_l0ha__"